import { useMemo } from "react";
import { ServiceReservation } from "../../../graphql/models";
import { useFormatter } from "../../../hooks";

export interface ServiceReservationPriceProps {
  reservation: ServiceReservation;
}

export function ServiceReservationPrice(props: ServiceReservationPriceProps) {
  const { reservation } = props;
  const { totalPrice, rectifiedPrice } = reservation;
  const { currency } = useFormatter();
  const withRectifiedPrice = useMemo(() => !!rectifiedPrice, [rectifiedPrice]);
  const tPrice = useMemo(() => currency(totalPrice), [totalPrice, currency]);
  const rPrice = useMemo(() => {
    return withRectifiedPrice ? currency(rectifiedPrice as number) : "";
  }, [rectifiedPrice, withRectifiedPrice, currency]);
  return (
    <strong>
      ➜
      {withRectifiedPrice && (
        <>
          <s>{tPrice}</s> {rPrice}
        </>
      )}
      {!withRectifiedPrice && tPrice}
    </strong>
  );
}
